/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { i18next } from '@fai/third-party/i18n';
import { EN as uiEN, KO as uiKO } from '@fai/translations/ui';

import suiteEN from './en.json';
import suiteKO from './ko.json';

const resources = {
  en: { translation: { ...uiEN, ...suiteEN } },
  ko: { translation: { ...uiKO, ...suiteKO } },
};

export default i18next(resources);
